import React, {useContext} from 'react'
import { Popup, Table, Image, Header, Icon } from 'semantic-ui-react';
import PropTypes from "prop-types";
import moment from 'moment';
import _ from 'lodash'
import {GetFullName} from '../../components/shared/utils'
import { ReservationStatusTypes } from '../../components/shared/statustypes'
import { getNationalityNameById } from '../../components/shared/nationalities';
import LanguageContext from '../../language';
import { Images } from '../../assets/assets';
import { endpoint } from '../../api/http';
import { dateTimeFormatSpaced } from '../../components/shared/constants';


const SchedulerPopup = (props) => {
    const reservation = props.reservation
    let image = Images.male_avatar;
    let title = ""
    let addons = []

    if (reservation) {
        if (reservation.Guest) {
            if (reservation.Guest.Images && reservation.Guest.Images.length > 0) {
                image = `${endpoint + reservation.Guest.Images[0].Path}`
            } else if (reservation.Guest.Gender === "F") {
                image = Images.female_avatar
            }
            title = GetFullName(reservation.Guest)
        }
        addons = _.uniq(_.map(reservation.ReservationDailyAddons, addon=>{
            return addon.HotelAddon.ChainAddon.Name
        }))
    }
    
    const language = useContext(LanguageContext)
    const text = key=>{
        return language?language.texts[key]:key
    }

    return (
        reservation ?
        <Popup className="tapechart-popup" open={props.open} context={props.context} position="top center" wide="very">
            <Popup.Header style={{borderBottomColor: reservation.Color, borderBottomWidth: "0.2em"}}>
                <Table singleLine basic='very' compact="very">
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width="1" className={"popup-title-tooltip-calendar"}>{title}</Table.Cell>
                            <Table.Cell width="1">{reservation.Number}</Table.Cell>
                            <Table.Cell width="16" className="status">{text(ReservationStatusTypes[reservation.StatusId])}</Table.Cell>
                            {reservation.ConfirmationDate && <Table.Cell width="1"><Icon color="green" name="check"/></Table.Cell>}
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Popup.Header>
            <Popup.Content>
                <Image size='tiny' avatar src={image} />
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <Header size="tiny" content={`${text("CheckIn")}:`} subheader={moment(reservation.CheckInDate).format(dateTimeFormatSpaced)} />
                                </td>
                                <td>
                                    <Header size="tiny" content={`${text("CheckOut")}:`} subheader={moment(reservation.CheckOutDate).format(dateTimeFormatSpaced)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Header size="tiny" content={`${text("Guests")}:`} subheader={reservation.Adults + " / " + reservation.Children + " / " + reservation.Infants} />
                                </td>
                                <td>
                                    <Header size="tiny" content={`${text("Agent")} / ${text("Company")}:`} subheader={(reservation.Agent ? reservation.Agent.Name : "-") + " / " + (reservation.Company ? reservation.Company.Name : "-")} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                <Header
                                size = 'tiny'
                                content = {
                                  `${text('Nationality')}:`
                                }
                                subheader = {
                                  reservation.Guest.NationalityId ?
                                  getNationalityNameById({
                                    NationalityId: reservation.Guest.NationalityId,
                                  }) :
                                    '-'
                                }
                                />
                                </td>
                            </tr>
                            {!props.displayPrice &&
                                <tr className={"popup-addons"}>
                                    <td colSpan="2">
                                        <Header  size="tiny" content={`${text("Addons")}:`} subheader={
                                            <Header.Subheader style={{maxWidth: "20em", whiteSpace: "normal"}}> {addons.length?_.join(addons, ", "):"-"}</Header.Subheader>
                                        } />
                                    </td>    
                                </tr>
                            }
                            {props.displayPrice &&
                                <tr className={"popup-addons"}>
                                    <td>
                                        <Header  size="tiny" content={`${text("Addons")}:`} subheader={
                                            <Header.Subheader style={{maxWidth: "20em", whiteSpace: "normal"}}> {addons.length?_.join(addons, ", "):"-"}</Header.Subheader>
                                        } />
                                    </td>
                                    <td>
                                        <Header size="tiny" content={text("Price")} subheader={reservation.price} />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Popup.Content>
        </Popup> : null
    )
}


SchedulerPopup.propTypes = {
    reservation: PropTypes.object,
    open: PropTypes.bool,
    context: PropTypes.any,
    displayPrice: PropTypes.bool
}

SchedulerPopup.defaultProps = {
    displayPrice: false
};

export default SchedulerPopup